import { useEffect, useState } from "react";
import OrderQueryTool from "./OrderQueryTool";

/* ── Araç tanımları ── */
type ToolId = "order";

interface ToolDef {
  id: ToolId;
  label: string;
  icon: string;
  description: string;
}

const TOOLS: ToolDef[] = [
  { id: "order", label: "Sipariş Sorgulama", icon: "bi-receipt-cutoff", description: "Sipariş koduyla durum ve detay" },
];

/* ── Modal ── */
export function AgentToolsModal({ onClose }: { onClose: () => void }) {
  const [activeTool, setActiveTool] = useState<ToolId>("order");
  const [isNarrow, setIsNarrow] = useState(window.innerWidth < 640);

  useEffect(() => {
    const onResize = () => setIsNarrow(window.innerWidth < 640);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  /* Küçük ekranda tam ekran, büyükte ortalanmış panel */
  const panelStyle: React.CSSProperties = isNarrow
    ? {
        position: "fixed", inset: 0, zIndex: 2050,
        background: "#fff",
        display: "flex", flexDirection: "column",
        overflow: "hidden",
      }
    : {
        position: "fixed", top: "50%", left: "50%", zIndex: 2050,
        transform: "translate(-50%, -50%)",
        width: "min(820px, calc(100vw - 24px))",
        maxHeight: "88dvh",
        background: "#fff",
        borderRadius: 20,
        boxShadow: "0 24px 64px rgba(0,0,0,0.18)",
        display: "flex", flexDirection: "column",
        overflow: "hidden",
      };

  return (
    <>
      {/* Backdrop (sadece geniş ekranda görünür) */}
      {!isNarrow && (
        <div
          onClick={onClose}
          style={{
            position: "fixed", inset: 0, zIndex: 2040,
            background: "rgba(0,0,0,0.5)",
            backdropFilter: "blur(4px)",
          }}
        />
      )}

      <div style={panelStyle}>
        {/* Header */}
        <div style={{
          padding: isNarrow ? "14px 16px" : "16px 20px",
          background: "linear-gradient(135deg, #1e1b4b, #312e81)",
          display: "flex", alignItems: "center", gap: 12,
          flexShrink: 0,
        }}>
          <div style={{
            width: 38, height: 38, borderRadius: 10, flexShrink: 0,
            background: "rgba(255,255,255,0.15)",
            display: "flex", alignItems: "center", justifyContent: "center",
          }}>
            <i className="bi bi-tools text-white" style={{ fontSize: "1rem" }} />
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 800, fontSize: "0.96rem", color: "#fff" }}>Araçlar</div>
            <div style={{ fontSize: "0.66rem", color: "rgba(255,255,255,0.6)" }}>Temsilci yardım araçları</div>
          </div>
          <button
            onClick={onClose}
            style={{
              background: "rgba(255,255,255,0.15)", border: "none",
              borderRadius: 9, width: 36, height: 36,
              display: "flex", alignItems: "center", justifyContent: "center",
              cursor: "pointer", color: "#fff", fontSize: "0.9rem",
            }}
          >
            <i className="bi bi-x-lg" />
          </button>
        </div>

        {/* Küçük ekran: yatay sekme çubuğu */}
        {isNarrow && TOOLS.length > 1 && (
          <div style={{
            display: "flex", overflowX: "auto", gap: 0,
            borderBottom: "1.5px solid #f1f5f9", background: "#fafafa",
            flexShrink: 0,
          }}>
            {TOOLS.map((t) => {
              const isActive = activeTool === t.id;
              return (
                <button
                  key={t.id}
                  onClick={() => setActiveTool(t.id)}
                  style={{
                    padding: "10px 16px", border: "none",
                    borderBottom: isActive ? "2.5px solid #6366f1" : "2.5px solid transparent",
                    background: "transparent", cursor: "pointer",
                    display: "flex", alignItems: "center", gap: 6,
                    fontWeight: isActive ? 700 : 500, fontSize: "0.82rem",
                    color: isActive ? "#4f46e5" : "#6b7280",
                    whiteSpace: "nowrap", flexShrink: 0,
                  }}
                >
                  <i className={`bi ${t.icon}`} />
                  {t.label}
                </button>
              );
            })}
          </div>
        )}

        {/* Büyük ekran: yan yana layout */}
        {!isNarrow ? (
          <div style={{ display: "flex", flex: 1, overflow: "hidden" }}>
            {/* Sol sidebar */}
            <div style={{
              width: 210, flexShrink: 0,
              borderRight: "1.5px solid #f1f5f9",
              background: "#fafafa",
              padding: "10px 8px",
              display: "flex", flexDirection: "column", gap: 4,
              overflowY: "auto",
            }}>
              <div style={{ fontSize: "0.6rem", fontWeight: 700, color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.06em", padding: "4px 8px 6px" }}>
                Araçlar
              </div>
              {TOOLS.map((t) => {
                const isActive = activeTool === t.id;
                return (
                  <button
                    key={t.id}
                    onClick={() => setActiveTool(t.id)}
                    style={{
                      background: isActive ? "#eef2ff" : "transparent",
                      border: isActive ? "1.5px solid #c7d2fe" : "1.5px solid transparent",
                      borderRadius: 10, padding: "9px 10px",
                      textAlign: "left", cursor: "pointer",
                      display: "flex", alignItems: "flex-start", gap: 8,
                      transition: "all 0.12s",
                    }}
                  >
                    <i
                      className={`bi ${t.icon}`}
                      style={{ fontSize: "0.95rem", color: isActive ? "#6366f1" : "#9ca3af", flexShrink: 0, marginTop: 1 }}
                    />
                    <div>
                      <div style={{ fontSize: "0.78rem", fontWeight: isActive ? 700 : 600, color: isActive ? "#4f46e5" : "#374151", lineHeight: 1.2 }}>
                        {t.label}
                      </div>
                      <div style={{ fontSize: "0.62rem", color: "#9ca3af", marginTop: 1, lineHeight: 1.3 }}>
                        {t.description}
                      </div>
                    </div>
                  </button>
                );
              })}
            </div>

            {/* Sağ içerik */}
            <div style={{ flex: 1, overflowY: "auto" }}>
              {activeTool === "order" && <OrderQueryTool compact={false} />}
            </div>
          </div>
        ) : (
          /* Küçük ekran: içerik tam genişlik, kaydırılabilir */
          <div style={{ flex: 1, overflowY: "auto" }}>
            {activeTool === "order" && <OrderQueryTool compact={true} />}
          </div>
        )}

        {/* Footer */}
        <div style={{
          padding: isNarrow ? "12px 16px" : "12px 20px",
          borderTop: "1.5px solid #f1f5f9",
          background: "#fafafa", display: "flex", justifyContent: "flex-end",
          flexShrink: 0,
        }}>
          <button
            onClick={onClose}
            style={{
              background: "#fff", border: "1.5px solid #e5e7eb",
              borderRadius: 10,
              padding: isNarrow ? "11px 0" : "7px 22px",
              width: isNarrow ? "100%" : "auto",
              fontWeight: 700, fontSize: "0.88rem", color: "#374151",
              cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
            }}
          >
            <i className="bi bi-x-lg" /> Kapat
          </button>
        </div>
      </div>
    </>
  );
}
